var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "@emotion/styled";
import { css } from "@emotion/react";
export var prefix = "summary-table";
export var SummaryTable = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (_a) {
    var theme = _a.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\t\tborder-radius: ", ";\n\t\t\toverflow: hidden;\n\t\t"], ["\n\t\t\tborder-radius: ", ";\n\t\t\toverflow: hidden;\n\t\t"])), theme.dimensions.borderRadius);
});
var templateObject_1, templateObject_2;
